import { GLOBAL_THEME } from 'commons-ui';

const KYC_STATUS_VALUE = {
	REJECTED: 'REJECTED',
	APPROVED: 'APPROVED',
	NOT_INITIATED: 'NOT_INITIATED',
	PENDING: 'PENDING',
	ERROR: 'ERROR',
	NAME_MISMATCH: 'NAME_MISMATCH',
	ALLOWED: 'ALLOWED',
	PROCESSING: 'PROCESSING'
};

export const MANUAL_VERIFICATION_OPTIONS = {
	REQ: 'REQUIRED',
	NOT_REQ: 'NOT_REQUIRED'
};
export const MANUAL_VERIFICATION_REQ_LABEL = {
	[MANUAL_VERIFICATION_OPTIONS.REQ]: 'Yes',
	[MANUAL_VERIFICATION_OPTIONS.NOT_REQ]: 'No'
};
export const MANUAL_VERIFICATION_REQ_VALUE_OPTIONS_MAP = {
	true: MANUAL_VERIFICATION_OPTIONS.REQ,
	false: MANUAL_VERIFICATION_OPTIONS.NOT_REQ
};

const KYC_STATUS_VALUE_COLOR_MAP = {
	[KYC_STATUS_VALUE.REJECTED]: GLOBAL_THEME.Colors.cellRed,
	[KYC_STATUS_VALUE.APPROVED]: GLOBAL_THEME.Colors.cellGreen,
	[KYC_STATUS_VALUE.NOT_INITIATED]: GLOBAL_THEME.Colors.cellGrey,
	[KYC_STATUS_VALUE.PENDING]: GLOBAL_THEME.Colors.cellOrange,
	[KYC_STATUS_VALUE.NAME_MISMATCH]: GLOBAL_THEME.Colors.cellOrange
};

const VIEW_FIELD_KEYS = {
	KYC_DETAILS_SCREEN: 'kycDetailsScreen',
	KYC_STATUS: 'status',
	MANUAL_VERIFICATION_REQ: 'manualVerificationRequired',
	APPROVED_BY: 'approvedBy',
	KYC_ID: 'kycId',

	KYC_DETAILS: 'kyc_details',
	DATE_OF_BIRTH: 'dob',
	DOC_IMAGE: 'documentImage',
	DOC_NUMBER: 'documentNumber',
	DOC_TYPE: 'documentType',
	REJECTION_MESSAGE: 'message',
	EXTERNAL_MESSAGE: 'externalMessage',
	FIRST_NAME: 'firstName',
	LAST_NAME: 'lastName',
	FULL_NAME: 'fullName',
	TIMESTAMP: 'timestamp',
	LAST_UPDATED_AT: 'lastUpdatedAt',
	UID: 'uid',

	OCR_RESULT: 'ocrResult',
	LAST_ID: 'last_id',
	MERCHANT: 'merchant',
	OCR_RESULT_STATUS: 'status',

	OCR_RESULT_MSG: 'msg',
	AGE: 'age',
	DOI: 'doi',
	FATHER_NAME: 'father_name',
	IS_SCANNED: 'is_scanned',
	MINOR: 'minor',
	SCAN_TYPE: 'scan_type',

	DEVICE_TYPE: 'deviceType'
};

export interface IKycDocumentFields {
	uid: number | null;
	documentImage: string | null;
	documentNumber: string | null;
	documentType: string | null;
	dob: string | null;
	firstName: string | null;
	lastName: string | null;
	fullName: string | null;
	status: string | null;
	ocrResult: any | null;
	externalMessage: string | null;
	timestamp: number | null;
	lastUpdatedAt: number | null;
	deviceType: string | null;
	message: string | null;
	kycId: string | null;
	manualVerificationRequired: boolean | null;
	upiId?: string | null;
}

export interface IFormattedKycData {
	[VIEW_FIELD_KEYS.KYC_STATUS]: string;
	[VIEW_FIELD_KEYS.KYC_ID]: string | null;
	[VIEW_FIELD_KEYS.MANUAL_VERIFICATION_REQ]: string | null;
	[VIEW_FIELD_KEYS.APPROVED_BY]: string | null;
	[VIEW_FIELD_KEYS.KYC_DETAILS]: {
		[VIEW_FIELD_KEYS.DATE_OF_BIRTH]: string | null;
		[VIEW_FIELD_KEYS.DOC_NUMBER]: string | null;
		[VIEW_FIELD_KEYS.DOC_IMAGE]: string | null;
		[VIEW_FIELD_KEYS.DOC_TYPE]: string | null;
		[VIEW_FIELD_KEYS.REJECTION_MESSAGE]: string | null;
		[VIEW_FIELD_KEYS.FIRST_NAME]: string | null;
		[VIEW_FIELD_KEYS.LAST_NAME]: string | null;
		[VIEW_FIELD_KEYS.FULL_NAME]: string | null;
		[VIEW_FIELD_KEYS.TIMESTAMP]: string | null;
		[VIEW_FIELD_KEYS.LAST_UPDATED_AT]: string | null;
		[VIEW_FIELD_KEYS.UID]: number | null;
		[VIEW_FIELD_KEYS.OCR_RESULT]: {
			[key: string]: any;
		};
		[VIEW_FIELD_KEYS.DEVICE_TYPE]: string | null;
	};
}

export { KYC_STATUS_VALUE, VIEW_FIELD_KEYS, KYC_STATUS_VALUE_COLOR_MAP };
export const NON_TERMINAL_STATUSES = [
	KYC_STATUS_VALUE.PENDING,
	KYC_STATUS_VALUE.APPROVED,
	KYC_STATUS_VALUE.PROCESSING,
	KYC_STATUS_VALUE.NOT_INITIATED
];

export const PAN_MESSAGE_CONSTANTS = {
	confirmationHeader: 'Confirm PAN Approval',
	confirmationMessage: 'Are you sure you want to approve this PAN?',
	agreeLabel: 'Yes, Approve',
	closeLabel: 'Cancel'
};
